"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimImageParam = exports.cropImage = void 0;
/**
 * @param {object} sizeUpdate - contains trim info
 * @returns an object containinig the image `trim` URL param
 *          or `undefined` if trim info missing
 */
const trimImageParam = sizeUpdate => {
  if (!sizeUpdate || !('trimData' in sizeUpdate) || !sizeUpdate.trimData) {
    return;
  }
  const trim = sizeUpdate.trimData;
  return {
    trim: `${trim.top},${trim.right},${trim.bottom},${trim.left}`
  };
};

/**
 * This function handles image cropping on article and section page
 * hero image ratio should be handled and passed from front end
 * body image can be selected by user, and it's under crop object, we need to pass crop function from frontend as well
 * section component images cropped by their image ratio, i.e If hero image ratio is approx. 1:1 it should use this crop from cms

 * @param {object} sizeUpdate - contains trim info
 * @returns a string containing the image `trim` URL param or the empty string if trim info missing
 */
exports.trimImageParam = trimImageParam;
const cropImage = crop => {
  const trimParamObj = trimImageParam(crop);
  if (!trimParamObj) return '';
  return `trim=${trimParamObj.trim}&`;
};
exports.cropImage = cropImage;